import React from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: "14px",
  padding: "12px 16px",
  fontSize: "15px",
  fontWeight: "600",
  textTransform: "none",
  letterSpacing: "0.5px",
  minWidth: "100px",
  width: "100%",
  position: "relative",
  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
  boxShadow: "none",

  // Selected state (contained style with green)
  ...(selected && {
    background: "linear-gradient(135deg, #7cc890 0%, #6bb57f 100%)",
    color: "white",
    border: "1px solid rgba(124, 200, 144, 0.3)",
    "&:hover": {
      background: "linear-gradient(135deg, #6bb57f 0%, #5aa46e 100%)",
      boxShadow: "0 8px 20px rgba(124, 200, 144, 0.4)",
      transform: "translateY(-2px)",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  }),

  // Unselected state (outlined style)
  ...(!selected && {
    background:
      "linear-gradient(135deg, rgba(255, 255, 255, 0.9) 0%, rgba(252, 255, 253, 0.8) 100%)",
    color: "#053251",
    border: "2px solid rgba(124, 200, 144, 0.3)",
    "&:hover": {
      background:
        "linear-gradient(135deg, rgba(124, 200, 144, 0.08) 0%, rgba(124, 200, 144, 0.05) 100%)",
      borderColor: "rgba(124, 200, 144, 0.5)",
      boxShadow: "0 4px 12px rgba(124, 200, 144, 0.2)",
      transform: "translateY(-1px)",
      color: "#053251",
    },
    "&:active": {
      transform: "translateY(0px)",
    },
  }),

  "&::before": {
    content: '""',
    position: "absolute",
    inset: 0,
    borderRadius: "14px",
    padding: "1px",
    background: selected
      ? "linear-gradient(135deg, rgba(255, 255, 255, 0.3), transparent)"
      : "linear-gradient(135deg, rgba(124, 200, 144, 0.3), transparent)",
    mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    maskComposite: "xor",
    WebkitMask:
      "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
    WebkitMaskComposite: "xor",
    opacity: 0.8,
  },

  "&::after": {
    content: '""',
    position: "absolute",
    top: "90%",
    left: "50%",
    transform: "translateX(-50%)",
    width: selected ? "25px" : "0px",
    height: "2px",
    background: selected
      ? "rgba(255, 255, 255, 0.4)"
      : "rgba(124, 200, 144, 0.5)",
    borderRadius: "1px",
    transition: "all 0.3s ease",
  },

  "& span": {
    position: "relative",
    zIndex: 1,
    fontWeight: "600",
    fontSize: "15px",
    letterSpacing: "0.3px",
  },

  "@media (max-width: 768px)": {
    padding: "8px 8px",
    fontSize: "14px",
    minWidth: "80px",
    "& span": {
      fontSize: "14px",
    },
  },
}));

const SlotContainer = styled("div")(({ theme }) => ({
  position: "relative",
  marginBottom: "12px",

  "@media (max-width: 768px)": {
    marginBottom: "8px",
  },
}));

const ReserveSlotItme = ({ selectedSlot, slot, handleSlotClick }) => {
  const isSelected = selectedSlot === slot;

  return (
    <SlotContainer className="col-3 col-md-auto">
      <StyledButton
        className=""
        selected={isSelected}
        variant={isSelected ? "contained" : "outlined"}
        onClick={() => handleSlotClick(slot)}
      >
        <span>{slot.slice(0, 5)}</span>
      </StyledButton>
    </SlotContainer>
  );
};

export default ReserveSlotItme;
